import axiosInstance from "../../../common/axiosInstance";

export const getEmployees = async () => {
  try {
    console.log(
      "========== GET EMPLOYEES =========="
    );

    const response =
      await axiosInstance.get("/employees");

    console.log(
      "GET EMPLOYEES RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "========== GET EMPLOYEES ERROR =========="
    );

    console.error(
      "STATUS:",
      error.response?.status
    );

    console.error(
      "RESPONSE:",
      error.response?.data
    );

    throw error;
  }
};

/**
 * =========================================
 * GET PROJECT MEMBERS
 * GET /projects/{project_uuid}/members
 * =========================================
 */
export const getProjectMembers = async (
  projectUuid
) => {
  try {
    console.log(
      "========== GET PROJECT MEMBERS =========="
    );

    console.log(
      "PROJECT UUID:",
      projectUuid
    );

    const response =
      await axiosInstance.get(
        `/projects/${projectUuid}/members`
      );

    console.log(
      "PROJECT MEMBERS RESPONSE:",
      response.data
    );

    return response.data;

  } catch (error) {
    console.error(
      "========== GET PROJECT MEMBERS ERROR =========="
    );

    console.error(
      "STATUS:",
      error.response?.status
    );

    console.error(
      "RESPONSE:",
      error.response?.data
    );

    console.error(
      "MESSAGE:",
      error.response?.data?.message
    );

    throw error;
  }
};